import React from 'react';
import { Box } from '@material-ui/core';
import FsUserDetailsForm from 'ui-elements/forms/FsUserDetailsForm';
import { passwordUpdateProps, userDetailsProps } from './ProfileSettings.utils';
import PasswordUpdate from './PasswordUpdate';

const ProfileSettings: React.FC = () => {
  return (
    <>
      <Box marginBottom={4}>
        <FsUserDetailsForm {...userDetailsProps} />
      </Box>
      <PasswordUpdate {...passwordUpdateProps} />
    </>
  );
};

export default ProfileSettings;
